import React, { useState } from "react";
import Layout from "../form-layout";

// Form B Q5 — "Have you experienced any side effects from your current treatment?"
// No -> continue straight to Q6. Yes -> open the symptom/severity/status module
// (current-side-effects-module.jsx, id "b5a") before continuing to Q6.
export default function CurrentSideEffects({ formData, setFormData, onBack, goToStep }) {
  const [answer, setAnswer] = useState(formData.hasCurrentSideEffects || "");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!answer) return;

    setFormData((prev) => ({ ...prev, hasCurrentSideEffects: answer }));
    localStorage.setItem("hasCurrentSideEffects", answer);

    goToStep(answer === "Yes" ? "b5a" : "b6");
  };

  return (
    <Layout goToStep={goToStep} onBack={onBack}>
      <h2 className="text-sm sm:text-[14px] font-medium text-[#000000] mb-6">
        Have you experienced any side effects from your current treatment?
      </h2>

      <form onSubmit={handleSubmit} className="flex flex-col gap-3">
        {["No", "Yes"].map((option) => (
          <label key={option} className="flex items-center gap-2 p-3 rounded-lg cursor-pointer border transition-all text-sm">
            <input
              type="radio"
              name="hasCurrentSideEffects"
              checked={answer === option}
              onChange={() => setAnswer(option)}
              className="h-4 w-4 accent-sky-400 cursor-pointer"
            />
            <span>{option}</span>
          </label>
        ))}

        <div className="flex justify-start mt-4">
          <button
            type="submit"
            disabled={!answer}
            className={`w-[210px] text-sm font-semibold rounded-lg py-3 transition-colors
              ${!answer ? "bg-gray-300 text-gray-600 cursor-not-allowed" : "bg-[#35C3D9] text-white hover:bg-[#27AAC0]"}`}
          >
            Next →
          </button>
        </div>
      </form>
    </Layout>
  );
}
